import { Serializable } from './serializable';

export class Consent implements Serializable<Consent> {
  private _id: string = '';
  public approved: boolean = false;
  public version: string = '';
  public approvalDate: Date = null;
  public userUuid: string = '';
  public consentType: string = '';

  /**
   * Gets entity id
   * @returns entity id
   */
  public getId(): string {
    return this._id;
  }

  /**
   * Transforms received object to Consent entity
   * @param input
   * @returns Consent entity
   */
  public deserialize(input: any = {}): Consent {
    if (!input) {
      return null;
    }

    const properties = Object.getOwnPropertyNames(this);
    Object.keys(input).forEach((key) => {
      if (input[key] !== null) {
        switch (key) {
          case 'id':
            this._id = input[key];
            break;

          case 'approvalDate':
            this[key] = new Date(input[key]);
            break;
          default:
            if (properties.includes(key)) {
              this[key] = input[key];
            }
            break;
        }
      }
    });

    return this;
  }

  /**
   * Transforms Consent entity to json object
   * @returns json object
   */
  public serialize(): any {
    const output = {};

    Object.getOwnPropertyNames(this).forEach((property) => {
      switch (property) {
        case '_id':
          if (this[property]) {
            output['id'] = this[property];
          }
          break;
        case 'approvalDate':
          output[property] =
            this[property] != null ? this[property].toString() : this[property];
          break;
        default:
          output[property] = this[property];
          break;
      }
    });

    return output;
  }
}
